<tt-page>
    <tt-list *ngIf="'mobile' | mediaQuery" class="col-xs-12 csp-0" [ttData]="itemsListPayCheckLs" [ttBadge]="'salaryhours'"></tt-list>
    <tt-grid *ngIf="(['tablet', 'laptop', 'desktop'] | mediaQuery) && !!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
